/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_sort = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort alphabetically`)
};

const es_rd_sort = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar alfabéticamente`)
};

const de_rd_sort = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alphabetisch sortieren`)
};

const nl_rd_sort = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfabetisch sorteren`)
};

const fr_rd_sort = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trier alphabétiquement`)
};

const it_rd_sort = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina alfabeticamente`)
};

const pt_br2_rd_sort = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificar alfabeticamente`)
};

const pt_rd_sort = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar alfabeticamente`)
};

const ja_rd_sort = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アルファベット順にソート`)
};

const zh_rd_sort = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按字母顺序排序`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_sort = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_sort(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_sort", locale)
	if (locale === "en") return en_rd_sort(inputs)
	if (locale === "es") return es_rd_sort(inputs)
	if (locale === "de") return de_rd_sort(inputs)
	if (locale === "nl") return nl_rd_sort(inputs)
	if (locale === "fr") return fr_rd_sort(inputs)
	if (locale === "it") return it_rd_sort(inputs)
	if (locale === "pt-BR") return pt_br2_rd_sort(inputs)
	if (locale === "pt") return pt_rd_sort(inputs)
	if (locale === "ja") return ja_rd_sort(inputs)
	return zh_rd_sort(inputs)
};